<template>
  <!-- contract manage -->
  <div>
    <el-row style="margin: 0" class="contract-wrap">
      <div class="org-tree">
        <h1 class="com-title com-ht tree-title"><i></i>文件管理</h1>
        <!-- contract tree -->
        <el-tree
          class="tree-style contract-tree"
          :data="treeGroup"
          :highlight-current="true"
          :expand-on-click-node="false"
          node-key="corpGroupId"
          :default-expand-all="true"
          :props="defaultProps"
          @node-click="handleNodeClick"
          ref="contractTree"
        >
          <div
            slot-scope="{ node, data }"
            class="wrap"
            :title="`${data.groupName}${
              filterModel.departmentId === data.corpGroupId
                ? `(${filterModel.pageTotal}份)`
                : ''
            }`"
          >
            <p
              :class="
                filterModel.departmentId === data.corpGroupId
                  ? 'name'
                  : 'name-full'
              "
            >
              {{ data.groupName }}
            </p>
            <span
              v-if="
                filterModel.departmentId === data.corpGroupId &&
                filterModel.pageTotal > 99
              "
              class="count"
              >(99<sup>+</sup>份)</span
            >
            <span
              v-if="
                filterModel.departmentId === data.corpGroupId &&
                filterModel.pageTotal <= 99
              "
              class="count"
              >({{ filterModel.pageTotal }}份)</span
            >
          </div>
        </el-tree>
      </div>
      <div class="right-box">
        <h1 class="com-title com-ht tree-title">
          <i></i>文件管理
          {{ selectTreeNode.groupName ? "-" : "" + selectTreeNode.groupName
          }}<span class="ms">/ 根据当前登录的权限范围查看合同</span>
        </h1>
        <div class="contract-box">
          <!-- contract table -->
          <!-- filter -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form
                :inline="true"
                :model="filterModel"
                size="small"
                class="demo-form-inline"
              >
                <el-form-item label="关键字">
                  <el-select
                    style="width: 110px"
                    v-model="filterModel.keywordType"
                    placeholder="请选择状态"
                  >
                    <el-option label="文件名称" :value="1"></el-option>
                    <el-option label="内部发起人" :value="2"></el-option>
                    <el-option label="内部签署人" :value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="filterModel.keyword"
                    placeholder="请输入"
                    style="width: 140px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="状态">
                  <!-- <el-select size="mini" v-model="filterModel.status" placeholder="请选择状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已过期" :value="1"></el-option>
                    <el-option label="已完成" :value="2"></el-option>
                    <el-option label="待签署" :value="3"></el-option>
                    <el-option label="已拒签" :value="4"></el-option>
                    <el-option label="审批中" :value="5"></el-option>
                  </el-select> -->
                  <!-- 改版后的状态 -->
                  <el-select
                    style="width: 100px"
                    v-model="filterModel.status"
                    placeholder="请选择状态"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待签署" :value="0"></el-option>
                    <el-option label="已完成" :value="1"></el-option>
                    <el-option label="已拒签" :value="2"></el-option>
                    <el-option label="待审批" :value="-3"></el-option>
                    <el-option label="审批驳回" :value="-4"></el-option>
                    <el-option label="已撤消" :value="-5"></el-option>
                    <el-option label="已过期" :value="-6"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="发送日期">
                  <el-date-picker
                    v-model="filterModel.timePicker"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 220px"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button @click="filterSearch">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <!-- table -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-table
                :data="tableList"
                style="border: 1px solid #eeeeee; border-bottom: 0"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
                :header-cell-style="{
                  background: '#f9f9f9',
                  color: '#333333',
                  fontWeight: '600',
                }"
              >
                <!-- <el-table-column type="selection" width="55"/> -->
                <el-table-column
                  label="合同名称"
                  prop="contractName"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="签署人" width="250" prop="signInfoVOS">
                  <template slot-scope="scope">
                    <el-tooltip placement="bottom-start">
                      <div
                        slot="content"
                        v-for="(item, inx) in scope.row.signInfoVOS"
                        style="
                          display: flex;
                          align-items: center;
                          padding-bottom: 5px;
                        "
                        :key="`qs${inx}`"
                      >
                        <span
                          v-if="item.orderNum && item.orderNum >= 1"
                          style="
                            margin-right: 5px;
                            display: block;
                            width: 13px;
                            height: 13px;
                            border-radius: 50%;
                            color: #ffffff;
                            border: 1px solid #ffffff;
                            text-align: center;
                            line-height: 13px;
                            font-size: 12px;
                          "
                          >{{ item.orderNum }}</span
                        >
                        <span v-else style="color: #ffffff; margin-right: 5px"
                          >·</span
                        >
                        <!--<div style="color: #ffffff;font-size: 12px;">【{{item.signStatus === 0?'未签署':item.signStatus === 1?'已签署':'已拒签'}}】</div>-->
                        <p style="color: #ffffff; font-size: 12px">
                          {{ item.signatoryFullName }}
                        </p>
                      </div>
                      <div>
                        <p class="textEllipsis">
                          {{ scope.row.signInfoVOS[0].signatoryFullName }}
                        </p>
                        <p
                          class="textEllipsis"
                          v-if="scope.row.signInfoVOS.length > 1"
                        >
                          {{ scope.row.signInfoVOS[1].signatoryFullName }}
                        </p>
                        <template>
                          <p
                            class="textEllipsis"
                            v-if="(scope.row.signInfoVOS.length === 3)"
                          >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                          <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
                        </template>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  label="发起人"
                  prop="ebqUserName"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="签署状态" prop="signStatus">
                  <!-- signStatus -3 审批 -2 草稿箱 -1 后台处理 0 未签 1 签署完成 2 拒签 -->
                  <!-- approveStatus 1 待审批 -1 审批拒绝 0 审批通过 -->
                  <!-- 改版了 2019-2-27 15:28:25 -->
                  <!-- 新版本用  signStatus 判断 -->
                  <!--
                    NOTINIT(-1,"后台处理中..."), //挂起合同的原因可能是在处理其它事情（如在下载证书或其它事情）
                    INPROGRESS(0, "待签"),
                    COMPLETED(1, "完成"),
                    REFUSE(2, "拒签"),
                    PRES(3, "已保全"),
                    DRAFT(-2,"草稿"),
                    WAIT_APPROVA(-3,"待审批"),
                    REFAULT_APPROVA(-4,"审批驳回"),
                    CANCLE(-5,"已撤消"),
                    EXIPRE(-6,"已过期"),;//已撤消，已过期，审批驳回
                   -->
                  <template slot-scope="scope">
                    <template>
                      <p>
                        <span
                          :class="
                            signStatusFilters[scope.row.signStatus].className
                          "
                          >●</span
                        >{{ signStatusFilters[scope.row.signStatus].text }}
                      </p>
                    </template>
                    <!-- <template slot-scope="scope">
                      <template v-if="scope.row.signStatus === -1">
                        <p><span class="dot-red">●</span> 后台处理中...</p>
                      </template>
                      <template v-else-if="scope.row.signStatus === 0">
                        <p><span class="dot-red">●</span> 待签署</p>
                      </template>
                      <template v-else-if="scope.row.signStatus === 1">
                        <p><span class="dot-green">●</span> 已完成</p>
                      </template>
                      <template v-else-if="scope.row.signStatus === 2">
                        <p><span class="dot-red">●</span> 已拒签</p>
                      </template>
                      <template v-else-if="scope.row.signStatus === -3">
                        <p><span class="dot-purple">●</span> 待审批</p>
                      </template>
                      <template v-else-if="scope.row.signStatus === -4">
                        <p><span class="dot-orange">●</span> 审批驳回</p>
                      </template>
                      <template v-else-if="scope.row.signStatus === -5">
                        <p><span class="dot-orange">●</span> 已撤消</p>
                      </template>
                      <template v-else-if="scope.row.signStatus === -6">
                        <p><span class="dot-orange">●</span> 已过期</p>
                      </template>
                    </template> -->
                  </template>
                </el-table-column>
                <el-table-column
                  label="发起时间"
                  prop="createTime"
                  show-overflow-tooltip
                >
                  <template
                    slot-scope="scope"
                    v-if="scope.row && scope.row.createTime"
                  >
                    {{ scope.row.createTime | formatDateHM }}
                  </template>
                </el-table-column>
                <!--<el-table-column label="完成时间" prop="signTime" show-overflow-tooltip>-->
                <!--<template slot-scope="scope" v-if="scope.row && scope.row.signTime">-->
                <!--{{scope.row.signTime | formatDateHM}}-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <a
                      class="color-success pointer"
                      @click="handleClickLookContract(scope.row)"
                      href="javascript:void(0);"
                      >查看</a
                    >
                    <template v-if="scope.row.signStatus === 1">
                      <span
                        class="color-success pointer"
                        @click="onGetCerti(scope.row)"
                        >证书</span
                      >
                      <certiServicepopover
                        listTyp="seniorList"
                        :param="{
                          signNo: scope.row.signNo || '',
                          applyNo: scope.row.applyNo || '',
                        }"
                      >
                        <span class="color-success">出证</span>
                      </certiServicepopover>
                    </template>
                  </template>
                </el-table-column>
                <no-data text="暂无数据" slot="empty" />
              </el-table>
            </el-col>
          </el-row>
          <!-- pagination -->
          <!--分页栏-->
          <el-row class="pageation">
            <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="filterModel.itemPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="filterModel.pageSize"
                layout="sizes, prev, pager, next, total"
                :total="filterModel.pageTotal"
              />
              <el-go
                :page-size="filterModel.pageSize"
                :total="filterModel.pageTotal"
                @current-change="handleCurrentChange"
              ></el-go>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-row>
    <certiServiceDialog
      v-if="cSDialogVisible"
      :dialogVisible="cSDialogVisible"
      :param="cSDialogData"
      @setCSDialogData="onSetCSDialogData"
    ></certiServiceDialog>
    <selectSubjectDialog
      v-if="sSDialogVisible"
      :dialogVisible="sSDialogVisible"
      :param="sSDialogData"
      @setSSDialogData="onSetSSDialogData"
    ></selectSubjectDialog>
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import ElGo from "../../components/go/Go";
import CertiServiceDialog from "@/components/apply-list/certiServiceDialog";
import SelectSubjectDialog from "@/components/apply-list/selectSubjectDialog";
import CertiServicepopover from "@/components/apply-list/certiServicepopover";
import { isInDingTalk } from '@/assets/js/utils/ding-env'

export default {
  name: "contract",
  components: {
    ElGo,
    CertiServiceDialog,
    SelectSubjectDialog,
    CertiServicepopover
  },
  data () {
    return {
      treeGroup: [],
      cSDialogVisible: false, //证书弹出框显示
      cSDialogData: {}, //证书弹出框数据
      sSDialogVisible: false, // 请选择出证主体身份弹出框显示
      sSDialogData: {}, //请选择出证主体身份数据
      selectContract: [],
      selectTreeNode: {}, // 选中的树节点
      defaultProps: {
        children: "childCorpGroups"
      },
      // filter model
      filterModel: {
        departmentId: "", // 部门id
        keywordType: 1, // 1 合同名称, 2 发起人, 3 签署人
        keyword: "",
        status: "",
        timePicker: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      tableList: [],
      // 签署状态
      signStatusFilters: {
        "-1": { text: "后台处理中", className: "dot-red" },
        "0": { text: "待签署", className: "dot-red" },
        "1": { text: "已完成", className: "dot-green" },
        "2": { text: "已拒签", className: "dot-red" },
        "-3": { text: "待审批", className: "dot-purple" },
        "-4": { text: "审批驳回", className: "dot-orange" },
        "-5": { text: "已撤消", className: "dot-orange" },
        "-6": { text: "已过期", className: "dot-orange" }
      }
    };
  },
  created () { },
  mounted () {
    this.initTreeGroup();
    this.initTableData();
  },
  methods: {
    /**
     *  签署方 string 分割为 签署方 array
     * */
    getQSF (str) {
      try {
        if (/\>/g.test(str)) {
          let arr = str.split(">").map((item, index) => {
            return {
              orderNum: index + 1,
              signatoryFullName: item
            };
          });
          return arr;
        }
        if (/\//g.test(str)) {
          let arr = str.split("/").map(item => {
            return {
              signatoryFullName: item
            };
          });
          return arr;
        }
        // 默认
        return [
          {
            signatoryFullName: str
          }
        ];
      } catch (e) {
        // 默认
        return [
          {
            signatoryFullName: str
          }
        ];
      }
    },
    async onGetCerti (rowData) {
      let _this = this;
      let _param;
      let viewUrlParam = {
        signNo: rowData.signNo || "",
        applyNo: rowData.applyNo || ""
      };
      let viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(viewUrlRes.description || "初始化数据失败");
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        _this.openCSDialog(certiRes.data);
      } else {
        let certiListRes = await ApiMethods.ApplySignController.certiList(
          _param
        );
        if (certiListRes.success) {
          if (!certiListRes.data || certiListRes.data.lengt == 0)
            return _this.$message.error("初始化数据失败");
          if (certiListRes.data.length === 1)
            return _this.openCSDialog(certiListRes.data[0]);
          if (certiListRes.data.length > 1)
            return _this.openSSDialog(certiListRes.data);
        } else {
          _this.$message.error(certiListRes.description);
        }
      }
    },
    openCSDialog (data) {
      this.cSDialogVisible = true;
      this.cSDialogData = data;
    },
    openSSDialog (data) {
      this.sSDialogVisible = true;
      this.sSDialogData = {
        certData: data
      };
    },
    onSetSSDialogData (data) {
      this.sSDialogVisible = data.sSDialogVisible;
      this.sSDialogData = {};
      if (data.sSDialogData) {
        this.openCSDialog(data.sSDialogData.certData);
      }
    },
    onSetCSDialogData (data) {
      this.cSDialogVisible = data.cSDialogVisible;
      this.cSDialogData = data.cSDialogData;
    },
    // convert data for tree formate
    // 转换成tree需要的数据格式
    convertFormateTree (data, number) {
      data.forEach(element => {
        element.label = element.groupName;
        if (
          number !== undefined &&
          this.filterModel.departmentId === element.corpGroupId
        ) {
          element.label = element.groupName + `(${number}份)`;
        }
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups, number);
        }
      });
      return data;
    },
    recursionChildren (childCorpGroups, number) {
      childCorpGroups.forEach(element => {
        element.label = element.groupName;
        if (
          number !== undefined &&
          this.filterModel.departmentId === element.corpGroupId
        ) {
          element.label = element.groupName + `(${number}份)`;
        }
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups, number);
        }
      });
    },
    // init org staructure data
    // 初始化组织机构数据
    initTreeGroup () {
      let params = {};
      params.permId = 5;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (res.code === "0") {
            this.treeGroup = this.convertFormateTree(res.data);
            this.$nextTick(() => {
              if (this.$refs.contractTree && this.$refs.contractTree.$el) {
                let firstTreeItem = this.$refs.contractTree.$el.querySelector(
                  "div"
                );
                firstTreeItem && firstTreeItem.classList.add("is-current");
              }
            });
            if (this.treeGroup && this.treeGroup.length > 0) {
              let firstElement = this.treeGroup[0];
              this.selectTreeNode = firstElement; // 赋初值
              this.filterModel.departmentId = firstElement.corpGroupId;
              this.queryTool();
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          console.info(error);
          this.$message.error(error.description);
        });
    },
    // tree node click event
    // 点击节点触发事件
    handleNodeClick (data) {
      if (data && data.corpGroupId) {
        this.selectTreeNode = data;
        this.filterModel.departmentId = data.corpGroupId;
        this.filterModel.itemPage = 1;
        this.queryTool();
        this.$nextTick(() => {
          if (data.corpGroupId !== this.treeGroup[0].corpGroupId) {
            if (this.$refs.contractTree && this.$refs.contractTree.$el) {
              let firstTreeItem = this.$refs.contractTree.$el.querySelector(
                "div"
              );
              firstTreeItem && firstTreeItem.classList.remove("is-current");
            }
          }
        });
      }
    },
    // 重置部门合同份数
    resetContractNumberIntoDept (number) {
      this.convertFormateTree(this.treeGroup, number);
    },
    // table filter event about search and move org and add contract
    // search event
    // 搜索按钮
    filterSearch () {
      this.filterModel.itemPage = 1;
      this.queryTool();
    },

    // table related events
    // query contract table data
    // 获取成员数据
    queryTool () {
      let params = {};
      params.itemPage = this.filterModel.itemPage; // 页数
      params.pageSize = this.filterModel.pageSize; // 页长
      params.beginDate = "";
      params.endDate = "";
      if (this.filterModel.timePicker) {
        params.beginDate = this.filterModel.timePicker[0]; // 开始时间 yyyy-MM-dd,必须与endDate同时存在才生效
        params.endDate = this.filterModel.timePicker[1]; // 结束时间 yyyy-MM-dd,必须与beginDate同时存在才生效
      }
      // params.applyNo = this.filterModel.applyNo // 合同编号
      // keywordType: 1, // 1 合同名称, 2 发起人, 3 签署人
      params.contractName = ""; // 合同名
      params.initUserName = ""; // 内部发起人全称(只有全称能查出记录)
      params.signUserName = ""; // 内部签署人全称(只有全称能查出记录)
      if (this.filterModel.keywordType === 1) {
        params.contractName = this.filterModel.keyword;
      }
      if (this.filterModel.keywordType === 2) {
        params.initUserName = this.filterModel.keyword;
      }
      if (this.filterModel.keywordType === 3) {
        params.signUserName = this.filterModel.keyword;
      }

      // 封装签署状态
      // <!-- signStatus -3 审批 -2 草稿箱 -1 后台处理 0 未签 1 签署完成 2 拒签 -5 -->
      // <!-- approveStatus 1 待审批 -1 审批拒绝 0 审批通过 -->
      // <!-- '' 全部 1 已过期 2 已完成 3 待签署 4 已拒签 5 审批中 -->

      // switch (this.filterModel.status) {
      // 	case 1:
      // 		params.signStatus = ''
      // 		break
      // 	case 2:
      // 		params.signStatus = 1
      // 		break
      // 	case 3:
      // 		params.signStatus = 0
      // 		break
      // 	case 4:
      // 		params.signStatus = 2
      // 		break
      // 	case 5:
      // 		params.signStatus = -3
      // 		break

      // 	default:
      // 		params.signStatus = ''
      // 		break
      // }

      params.signStatus = this.filterModel.status;

      params.corpGroupId = this.filterModel.departmentId; // 部门范围ID
      this.selectContract = undefined;
      ApiCorpMethods.ContractController.findByPage(params)
        .then(res => {
          if (res.code === "0") {
            res.data.forEach(item => {
              item.signInfoVOS = this.getQSF(item.allSignerName);
            });
            this.tableList = res.data;
            this.filterModel.pageTotal = res.total;
          } else {
            this.tableList = [];
            this.filterModel.pageTotal = 0;
            if (this.$store.getters.authUser.identityAuth > -1) {
              this.$message.error(res.description || "获取合同数据列表失败");
            }
          }
          this.resetContractNumberIntoDept(this.filterModel.pageTotal);
          // 通过接口获取 合同份数
          // let p = {}
          // p.corpGroupId = this.filterModel.departmentId // 部门范围ID
          // ApiCorpMethods.ContractController.contractNum(p).then(res => {
          // 	if (res.code === '0') {
          // 		this.resetContractNumberIntoDept(res.data || 0)
          // 	}
          // })
        })
        .catch(error => {
          console.info(error);
          this.$message.error(error);
        });
    },
    // init table data
    // 初始化成员table列表
    initTableData () {
      this.queryTool();
    },
    // selection change event
    // 当选择项发生变化时会触发该事件
    handleSelectionChange (val) {
      console.info(val, 6666);
      this.selectContract = val;
    },
    // handle click look up contract evnet
    // 查看合同
    handleClickLookContract (row) {
      let params = {};
      let newWind;
      if (!isInDingTalk) newWind = window.open();
      params.applyNo = row.applyNo;
      params.multiFile = row.multiFile;
      ApiCorpMethods.ContractController.viewUrl(params)
        .then(res => {
          if (res.code === "0") {
            let { href } = row.multiFile
              ? this.$router.resolve({
                path: "/applySign/toDetailMultiAnony",
                query: Object.assign({}, res.data, {
                  approveId: row.approveId
                })
              })
              : this.$router.resolve({
                path: "/applySign/toDetailAnony",
                query: Object.assign({}, res.data, {
                  approveId: row.approveId
                })
              });
            href = window.location.origin + href;
            isInDingTalk ? location.href = href : newWind.location.href = href;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // handle click unbind evnet
    // 解绑
    handleClickUnbind (row) {
      console.info(row);
      this.$confirm(
        `
					<h5>是否解除绑定</h5>
					<p style="color:#F56C6C">
						解除绑定后当前绑定的用户将无法使用,
						<span style="color:#666666">您还要继续吗?</span>
					</p>
				`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => { });
    },
    // handle click reinvite evnet
    // 重新邀请
    handleClickReinvite (row) {
      console.info(row);
      this.$confirm(
        `
					<h5>是否重新邀请</h5>
					<p style="color:#F56C6C">
						重新发起邀请,之前的邀请将会失效,
						<span style="color:#666666">您还要继续吗?</span>
					</p>
				`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => { })
        .catch(() => { });
    },
    // pagination event
    // 分页事件
    handleSizeChange (val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.queryTool();
    },
    handleCurrentChange (val) {
      this.filterModel.itemPage = val;
      this.queryTool();
    }
  }
};
</script>

<style lang="less">
@import url('../../assets/style/cssVariable.less');
.tree-style .el-tree-node.is-current > .el-tree-node__content {
  background-color: @ebq-left-selected;
}
</style>
<style lang="less" scoped>
.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*color: #290202;*/
  /*opacity: 0.65;*/
}

.wrap {
  width: calc(100% - 40px);
  font-size: 0;
  margin-left: 5px;

  .name {
    width: 100%;
    max-width: calc(100% - 50px);
    float: left;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 14px;
  }

  .name-full {
    width: 100%;
    float: left;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 14px;
  }

  .count {
    float: left;
    font-size: 14px;
  }
}

.dot-gray {
  color: #cccccc;
}

.dot-green {
  color: #67c23a;
}

.dot-red {
  color: #f56c6c;
}

.dot-orange {
  color: #e6a23c;
}

.dot-purple {
  color: #a68cf5;
}

/deep/ .contract-tree {
  margin-top: 30px;

  & > .el-tree-node {
    .is-current > .el-tree-node__content {
      color: #ec1c1c;

      &:before {
        background-image: url("/static/images/console/member-leafHover.png");
      }
    }

    & > .el-tree-node__content {
      &:before {
        background-image: url("/static/images/console/member-root.png");
      }
    }
  }

  .el-tree-node__label {
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  .el-tree-node__content {
    position: relative;
    margin-bottom: 5px;
    padding-left: 20px;

    &:before {
      position: absolute;
      content: "";
      display: inline-block;
      width: 15px;
      height: 15px;
      top: 50%;
      margin-left: 16px;
      margin-top: -8px;
      background-image: url("/static/images/console/member-leaf.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .el-icon-caret-right {
      position: relative;
      padding: 20px;
      margin-left: -20px;

      &.is-leaf {
        visibility: hidden;
      }

      &.expanded:before {
        height: 0;
      }
    }
  }
}

.contract-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}

.org-tree {
  border-radius: 2px;
  position: absolute;
  background: #ffffff;
  min-height: calc(100vh - 150px);
  width: 265px;
  top: 0;
  left: 0;
  bottom: 0;

  /*&:after {*/
  /*  content: '';*/
  /*  display: block;*/
  /*  position: absolute;*/
  /*  width: 1px;*/
  /*  height: 100%;*/
  /*  right: -1px;*/
  /*  top: 0;*/
  /*  background-color: #dddddd;*/
  /*}*/
}

.right-box {
  background: #ffffff;
  min-height: calc(100vh - 150px);
  margin-left: 280px;
  border-radius: 2px;

  .contract-box {
    padding: 20px;
  }
}

.color-success {
  color: #290202;
  font-weight: bold;
  margin-right: 6px;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
}

.color-success:hover {
  color: #ec1c1c;
}
</style>



// WEBPACK FOOTER //
// pages/console/contract.vue